import { c as _c } from "react/compiler-runtime";
import { Trans, useTranslation } from 'react-i18next';
import React from 'react';
import { SectionHeadline } from '@/components/SectionHeadline';
import { InfoBoxes } from '@/components/boxes';
import IconPay from '@/assets/icons/heroIcons/Pay.svg';
import IconThird from '@/assets/icons/heroIcons/Third.svg';
import IconWarranty from '@/assets/icons/heroIcons/Warranty.svg';
import { Link } from '@/components/links';
import { Text } from '@/components/typography';
import { LINKS } from '@/constants/links';
export function HowBNPLWorks() {
  const $ = _c(40);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["shopWisely"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation(t0);
  let t1;
  if ($[1] !== t) {
    t1 = t("howBNPLWorks.title");
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <SectionHeadline className="mb-4 lg:mb-6" anchorKey="howBNPLWorks.title">{t1}</SectionHeadline>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Link analyticsParam="shopWiselyWhereToShop" testId="shopWiselyWhereToShop" to={LINKS().whereToShop} />;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t) {
    t4 = <Text variant="p2" className="mx-auto mb-10 max-w-192 text-center text-gray-800 lg:mb-16"><Trans t={t} i18nKey="howBNPLWorks.text">{t3}</Trans></Text>;
    $[6] = t;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t) {
    t5 = t("howBNPLWorks.items.1.title");
    $[8] = t;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t) {
    t6 = t("howBNPLWorks.items.1.text");
    $[10] = t;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <IconPay />;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t5 || $[14] !== t6) {
    t8 = {
      title: t5,
      paragraph: t6,
      icon: t7
    };
    $[13] = t5;
    $[14] = t6;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t) {
    t9 = t("howBNPLWorks.items.2.title");
    $[16] = t;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t) {
    t10 = t("howBNPLWorks.items.2.text");
    $[18] = t;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <IconThird />;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== t10 || $[22] !== t9) {
    t12 = {
      title: t9,
      paragraph: t10,
      icon: t11
    };
    $[21] = t10;
    $[22] = t9;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== t) {
    t13 = t("howBNPLWorks.items.3.title");
    $[24] = t;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] !== t) {
    t14 = t("howBNPLWorks.items.3.text");
    $[26] = t;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  let t15;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <IconWarranty />;
    $[28] = t15;
  } else {
    t15 = $[28];
  }
  let t16;
  if ($[29] !== t13 || $[30] !== t14) {
    t16 = {
      title: t13,
      paragraph: t14,
      icon: t15
    };
    $[29] = t13;
    $[30] = t14;
    $[31] = t16;
  } else {
    t16 = $[31];
  }
  let t17;
  if ($[32] !== t12 || $[33] !== t16 || $[34] !== t8) {
    t17 = <InfoBoxes items={[t8, t12, t16]} variant="inverted" />;
    $[32] = t12;
    $[33] = t16;
    $[34] = t8;
    $[35] = t17;
  } else {
    t17 = $[35];
  }
  let t18;
  if ($[36] !== t17 || $[37] !== t2 || $[38] !== t4) {
    t18 = <div className="px-4">{t2}{t4}{t17}</div>;
    $[36] = t17;
    $[37] = t2;
    $[38] = t4;
    $[39] = t18;
  } else {
    t18 = $[39];
  }
  return t18;
}